import type { AutorizacaoTrabalhoRemotoFormDto } from '@/modules/people/presentation/person-form.utils';

/** Normaliza para yyyy-MM-dd (comparação lexicográfica segura para datas ISO). */
export function toDateKey(value?: string | Date | null): string | null {
  if (value == null || value === '') return null;
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    const y = value.getFullYear();
    const m = String(value.getMonth() + 1).padStart(2, '0');
    const d = String(value.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
  const s = String(value).trim();
  if (!s) return null;
  const match = s.match(/^(\d{4}-\d{2}-\d{2})/);
  return match ? match[1] : null;
}

export type PeriodoAutorizacao = {
  data_inicial?: string | Date | null;
  data_final?: string | Date | null;
};

/**
 * Intervalos [inicio, fim] (fim nulo = em aberto) se sobrepõem.
 * Contato no mesmo dia conta como colisão.
 */
export function periodosAutorizacaoColidem(a: PeriodoAutorizacao, b: PeriodoAutorizacao): boolean {
  const aIni = toDateKey(a.data_inicial);
  const bIni = toDateKey(b.data_inicial);
  if (!aIni || !bIni) return false;

  const aFim = toDateKey(a.data_final) ?? '9999-12-31';
  const bFim = toDateKey(b.data_final) ?? '9999-12-31';

  return aIni <= bFim && bIni <= aFim;
}

export function validarAutorizacaoTrabalhoRemoto(
  candidata: PeriodoAutorizacao,
  existentes: PeriodoAutorizacao[],
  indiceEdicao = -1,
): string | null {
  const inicio = toDateKey(candidata.data_inicial);
  if (!inicio) {
    return 'Informe a data inicial.';
  }

  const fim = toDateKey(candidata.data_final);
  if (fim && fim < inicio) {
    return 'A data final não pode ser anterior à data inicial.';
  }

  const colide = existentes.some((item, index) => {
    if (index === indiceEdicao) return false;
    if (!toDateKey(item.data_inicial)) return false;
    return periodosAutorizacaoColidem(candidata, item);
  });

  if (colide) {
    return 'O período informado colide com outra autorização de trabalho remoto.';
  }

  return null;
}

export function validarListaAutorizacoesTrabalhoRemoto(
  lista: AutorizacaoTrabalhoRemotoFormDto[],
): string | null {
  for (let i = 0; i < lista.length; i++) {
    const erro = validarAutorizacaoTrabalhoRemoto(lista[i], lista, i);
    if (erro) return erro;
  }
  return null;
}
